<template>
  <b-form-row>
    <b-modal size="md" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

      <b-form @submit.prevent="save">
        <b-card>
          <b-form-row>
            <lg-form-input invalidFeedback="A unidade Administrativa deve ser informado!" description=""
              :error="$v.form.departamento.id" v-model="form.departamento.descricao" label="Unidade Administrativa:* "
              disabled md="12" sm="12" />

            <b-form-group label="Localização Fisica:* " style="padding-left: 10px" md="12" sm="12">
              <b-form-radio-group invalidFeedback="A Localização física deve ser informada!" description=""
                :error="$v.form.selected" name="Localização Fisica" plain>
                <b-form-radio @change="mostrarLocalChange(false)" v-model="form.selected" :value="'0'" style="margin-top: -10px">Todas as
                  localizações</b-form-radio>
                <b-form-radio @change="mostrarLocalChange(true)" style="margin-top: -10px" v-model="form.selected" :value="'1'">Somente uma
                  localização</b-form-radio>
              </b-form-radio-group>
            </b-form-group>


            <div v-if="mostrarLocal" class="col-12">

              <lg-finder-page-local-armazenamento :departamento="form.localArmazenamento"
                :error="$v.form.localArmazenamento" v-model="form.localArmazenamento" id="finderLocal"
                @close="localArmazenamentoSelect" :prefix="title"
                invalidFeedback="É necessário escolher o Local de Armazenamento">
              </lg-finder-page-local-armazenamento>


            </div>

            <lg-form-input invalidFeedback="A justificativa deve ser informada!" description=""
              :error="$v.form.justificativa" md="12" sm="12" v-model="form.justificativa" label="Justificativa:*"
              rows="3" max-rows="5" />

            <lg-form-select :adicionarTodos="false" v-model="form.periodo" :loadFunction="periodoList"
              labelFormGroupBind="Período de Preferência: " label="descricao" cols="12" sm="12" md="12"
              invalidFeedback="O periodo deve ser informado!" description="" :error="$v.form.periodo"
              filterList="true" />

            <lg-form-input invalidFeedback="O Responsável deve ser informado!" description="" :error="$v.form.usuario"
              v-model="form.nomeRespCriacao" label="Responsável Criação: " cols="12" sm="12" md="12" disabled />

            <b-col cols="3"></b-col>
            <b-col cols="6" class="text-center">
              <b-button id="salcarSolicitacaoInventario" class=" my-2" size="sm" pill variant="success" @click="save">
                <b-icon icon="check-circle" />
                <b-tooltip target="salcarSolicitacaoInventario" title="Salvar"></b-tooltip>

              </b-button>

              <b-button id="cancelarSolicitacaoInventario" class=" my-2 ml-2" size="sm" pill variant="danger"
                @click="cancelar">
                <b-icon icon="x-circle" />
                <b-tooltip target="cancelarSolicitacaoInventario" title="Cancelar"></b-tooltip>

              </b-button>
            </b-col>
            <b-col cols="3"></b-col>

          </b-form-row>



        </b-card>
      </b-form>
    </b-modal>
  </b-form-row>
</template>
<script>
import { required, minLength } from "vuelidate/lib/validators";
import ResourceService from "@/core/api/ResourceService";
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";

import LgFinderPageLocalArmazenamento from "@/components/Finders/LgFinderPageLocalArmazenamento.vue";
import { FormResourceMixin } from "@/core/mixins/resource";
import TipoStatusEnum from "@/core/utils/TipoStatusEnum";

export default {
  components: {
    LgFormSelect,
    LgFormInput,
    LgFinderPageLocalArmazenamento,
  },

  validations: {
    form: {
      periodo: { required },
      justificativa: { required, minLength: minLength(1) },
      selected: { required },
      departamento: { required },
    },
  },



  mixins: [FormResourceMixin],

  props: {
    id: Number,
    prefix: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      showModal: true,
      title: "Cadastro",
      mostrarLocal: false,
      form: {
        justificativa: "",
        departamento: {nome:""},
        localArmazenamento: {id: null, descricao: ''},
        periodo: {},
        tipoSolicitacao: {},
        usuario: {},
        pessoa:{},
      },
    };
  },


  async beforeMount() {
    this.$statusService = new ResourceService(`/api/status/tipo/${TipoStatusEnum.PERIODO.cod}`);
    this.$serviceStatus = new ResourceService(`/api/status`);

    this.$service = new ResourceService(`/api/solicitacaoinventario`);


    if (this.id) {
      const { data } = await this.$service.findById(this.id);


      this.form = data;
      this.form.nomeRespCriacao = this.form.pessoa.nome;
      this.form.selected = data.localArmazenamento && data.localArmazenamento.id ? "1" : "0";
      this.mostrarLocal = this.form.selected == "1";
    }
    else {
      const brand = JSON.parse(localStorage.getItem("context"));
      this.form.departamento = brand.departamento;

      this.form.usuario = brand.usuario;
      this.form.nomeRespCriacao = brand.usuario.nome;


    }

  },

  methods: {
    mostrarLocalChange(mostrar){
      this.mostrarLocal = mostrar;
    },

    validateState(field) {
      if (!field.$dirty) {
        return null
      }
      return field.$invalid ? false : true
    },
    cancelar() {
      this.$emit("close");
    },

    async periodoList({ filter, page = 1 }) {
      const status = this.$statusService.findAll({ filter, page, limit: 5 });
      return status;
    },

    async save() {

      if (!this.formIsValid || (this.form.selected == '1' && (!this.form.localArmazenamento || !this.form.localArmazenamento.id))) {
        this.$v.$touch()
        this.$notify({
          type: "danger",
          message: "Verifique os campos do cadastro.",
        })
        return
      }

      if(this.form.selected == '0')
        this.form.localArmazenamento = undefined;

      try {
        await this.$saveResource(this.form);
        this.cancelar();
      }
      catch (error) {
        this.$notify({
          type: "danger",
          message: error,
        });

      }


    },

    async localArmazenamentoSelect(item) {
      this.form.localArmazenamento = item;
    },
  },
};
</script>
